import { render, staticRenderFns } from "./ContractorsNotesTab.vue?vue&type=template&id=ac882728&"
import script from "./ContractorsNotesTab.vue?vue&type=script&lang=js&"
export * from "./ContractorsNotesTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports